import { LOCATION_CHANGE } from 'react-router-redux';
import { Analytics } from './analytics';
export var createAnalyticsMiddleware = function (actionTypesToTrack) {
    return function (api) { return function (next) { return function (action) {
        if (action.type === LOCATION_CHANGE) {
            Analytics.trackPageLoad(action.payload.pathname);
        }
        else if (actionTypesToTrack.indexOf(action.type) !== -1) {
            Analytics.trackEvent(action.type, action.payload);
        }
        return next(action);
    }; }; };
};
//# sourceMappingURL=createAnalyticsMiddleware.js.map